import type { Article, Category, SupportSearchResults } from "../support.types";
import { findSupportArticleInCategory } from "./findSupportArticleInCategory";

/**
 * Groups search result articles by their category name.
 */
export function packSupportSearchResults(
  articles: Article[],
  categories: Category[]
): SupportSearchResults {
  const groupedResults: { [key: string]: Article[] } = {};

  articles.forEach((article) => {
    const category = findSupportArticleInCategory(categories, article.id);

    if (category) {
      if (!groupedResults[category.name]) {
        groupedResults[category.name] = [];
      }

      groupedResults[category.name].push(article);
    }
  });

  return groupedResults;
}

export default packSupportSearchResults;
